import axios from 'axios';
import { getTokenSensedia } from '../Utils/RefreshToken';

import portalEnvironment from '../Utils/baseURL';

import { sair, getCurrentAuthenticatedUser } from './auth';

import device from '../middlewares/deviceInfos';

const getToken = async () => {
  // solicita ao cognito um novo token do usuário autenticado
  let resultGetAuthenticatedUser = null;

  try {
    resultGetAuthenticatedUser = await getCurrentAuthenticatedUser();

    let tokenSensedia = await getTokenSensedia(
      resultGetAuthenticatedUser?.signInUserSession?.idToken.jwtToken
    );
    localStorage.removeItem('idTokenSens');
    localStorage.setItem('idTokenSens', tokenSensedia?.data?.access_token);

    return tokenSensedia?.data?.access_token;
  } catch (error) {
    await sair();
    return null;
  }
};

const api = axios.create({
  baseURL: portalEnvironment.BaseUrl,
  timeout: 300000,
  headers: {
    client_id: 'cdf44a30-32a4-3930-9e82-4ee8a8a7d8f0',
    access_token: localStorage.getItem('idTokenSens'),
    device: JSON.stringify(device),
  },
});

const setAuthorization = async (token) => {
  if (!token) api.defaults.headers.access_token = await getToken();
  else api.defaults.headers.access_token = await token;
};

api.interceptors.response.use(undefined, async (error) => {
  if (error?.response?.status === 403) {
    await sair();
  } else if (error?.response?.status === 401) {
    if (await callBackError401()) {
      error.config.headers.access_token = api.defaults.headers.access_token;
      return api.request(error.config);
    } else {
      // deslogar o sujeito
      await sair();
    }
  }
  return Promise.reject(error);
});

async function callBackError401() {
  try {
    let tempGetToken = await getToken();
    if (tempGetToken) {
      await setAuthorization(tempGetToken);
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}
export { api, setAuthorization, sair };
